import {
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { IconPlus, IconTrash, IconUser } from "@tabler/icons-react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import CustomTable from "../../../components/common/table/CustomTable";
import { useGetClientsByUserQuery } from "../../../services/clients/clientsServices";
import { useDisableUserClientMutation } from "../../../services/users/usersService";
import { useAppSelector } from "../../../store/hooks";
import AddClientToUserForm from "../forms/AddClientToUserForm";
import { useState, useEffect } from "react";

const TableClientsByUser = () => {
  const { userToEdit } = useAppSelector((state) => state.usuarios);
  const [showModal, setShowModal] = useState(false);

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const [idClientToDisable, setIdClientToDisable] = useState<
    number | undefined
  >();

  const { data, isLoading, isFetching, refetch } = useGetClientsByUserQuery({
    id_usuario: Number(userToEdit?.id) || NaN,
    page,
    size,
  });

  const [
    disableUsrClnt,
    {
      isLoading: isLoadingDisable,
      isError: isErrorDisable,
      error: errorDisable,
      isSuccess: isSuccessDisable,
      reset: resetDisable,
    },
  ] = useDisableUserClientMutation();

  const headers = [
    {
      id: "id",
      disablePadding: false,
      label: "ID",
      numeric: true,
    },
    {
      id: "name",
      disablePadding: false,
      label: "NOMBRE",
      numeric: false,
    },
    {
      id: "ruc",
      disablePadding: false,
      label: "RUC",
      numeric: false,
    },
    {
      id: "tipo",
      disablePadding: false,
      label: "TIPO",
      numeric: false,
    },
    {
      id: "options",
      disablePadding: false,
      label: "OPCIONES",
      numeric: false,
    },
  ];

  const handleSetIdToDisable = (id: number) => {
    setIdClientToDisable(id);
  };

  const handleDisableIdToDisable = async () => {
    await setIdClientToDisable(undefined);
    resetDisable();
  };

  const handleDisableUserClient = () => {
    disableUsrClnt({
      id_usuario: Number(userToEdit?.id!),
      id_cliente: idClientToDisable!,
    });
  };

  useEffect(() => {
    isSuccessDisable && refetch();
  }, [isSuccessDisable, refetch]);

  const rows =
    data?.data?.map((cl) => ({
      id: cl.id,
      name: cl.nombre,
      ruc: cl.ruc,
      tipo: cl.tipo,
      options: (
        <>
          <Tooltip title="Eliminar Empresa">
            <IconButton
              size="small"
              onClick={() => handleSetIdToDisable(Number(cl.id))}
            >
              <IconTrash color="red" />
            </IconButton>
          </Tooltip>
        </>
      ),
    })) || [];

  const openModal = () => {
    setShowModal(true);
  };

  if (!userToEdit) {
    return <Grid container spacing={2}></Grid>;
  }

  return (
    <>
      <Typography
        variant="h6"
        style={{ display: "flex", alignItems: "center" }}
      >
        <IconUser />
        &nbsp;{userToEdit.nombre?.toUpperCase()}
      </Typography>
      <Grid item xs={12} md={12} lg={12} style={{ textAlign: "right" }}>
        <Button
          onClick={openModal}
          variant="contained"
          color="primary"
          startIcon={<IconPlus />}
        >
          Agregar Empresa
        </Button>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <CustomTable
          isLoading={isLoading || isFetching}
          rows={rows}
          headers={headers}
          totalRecords={Number(data?.total) || 10}
          page={page}
          rowsPerPage={size}
          onChangePage={(page) => {
            setPage(page);
          }}
          onChangeRowsPerPage={(rowsPerPage) => {
            setSize(rowsPerPage);
          }}
        />
      </Grid>
      <CustomDialog
        isOpen={showModal}
        handleClose={() => setShowModal(false)}
        title="Agregar Empresa"
        hideActionButtons={true}
      >
        <AddClientToUserForm
          refetch={refetch}
          idUsuario={Number(userToEdit.id)}
          handleClose={() => setShowModal(false)}
        />
      </CustomDialog>
      <CustomDialog
        isOpen={Boolean(idClientToDisable)}
        handleClose={handleDisableIdToDisable}
        title="Eliminar Empresa"
        subtitle="¿Esta seguro de eliminar esta empresa?"
        textButton="Sí, Eliminar"
        handleSubmit={handleDisableUserClient}
        isError={isErrorDisable}
        errorMessage={String(errorDisable)}
        isLoading={isLoadingDisable}
        isSuccess={isSuccessDisable}
        successMessage="Empresa eliminada correctamente."
      >
        {null}
      </CustomDialog>
    </>
  );
};

export default TableClientsByUser;
